import React from 'react'
import { MainBlock } from '@blocks/BlockMain/model'
import { ProductListLoan } from '@shared/components/sections/product-loans/ItemDescription'

export const mainBlock: MainBlock = {
	title: <>Реферальная программа Сredit.Club</>,
	subtitle: 'Привлекайте заёмщиков и зарабатывайте вместе с нами',
	textItems: [
		'До 20 тысяч за сделку',
		'Вся нагрузка по сделке на нас',
		'Подключение к программе за 5 минут',
	],
	buttonText: 'Присоединиться',
	faceImageName: {
		mobile: 'referral-programs-mob.png',
		default: 'referral-programs.png',
	},
	imageAlt: 'Реферальная программа Сredit.Club',
}

export const productListLoan: ProductListLoan[] = [
	{
		id: 1,
		title: <>Банковская ставка&nbsp;&mdash; от&nbsp;14,9%&nbsp;годовых</>,
		description: ['Без страховок', <>Залог&nbsp;&mdash; квартира</>, 'Лояльны к кредитной истории'],
	},
	{
		id: 2,
		title: <>Срок&nbsp;— до&nbsp;20 лет</>,
		description: ['Заёмщик — физическое и юридическое лицо', 'Решение за 1–2 рабочих дней'],
	},
	{
		id: 3,
		title: <>От 200 тысяч до&nbsp;15&nbsp;млн&nbsp;рублей</>,
		description: ['170+ городов России'],
	},
]

export const partnerFormSummary = [
	'Оставьте заявку.',
	'Подключитесь к программе за 5 минут через нашего менеджера.',
	'Рассказывайте клиентам о кредитных программах Credit.Club и получайте вознаграждение.',
]

export const reasonList = [
	'Кредитным брокерам, которые не могут или не хотят сопровождать клиента',
	'Другим специалистам из сферы консалтинга и аутсорсинга',
	'Банковским сотрудникам',
	'Агентствам интернет-маркетинга',
	'Веб-мастерам',
	'Риелторам',
	'Бухгалтерам на аутсорсе',
	'Страховым агентам',
]
